import { Checkbox } from '@mui/material';
import { UPDATE_HOMESALE_PROPERTY_INFO_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { getHomesaleInfo, postHomesaleInfo, updateHomesalePropertyInfo } from 'modules/authorizations/store/actions/homesale.actions';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';

const PropertyInfoCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { isReadOnly, enumerations, typeOfHomesEnum } = props;
  const homesaleInfo = props.homesale ? props.homesale.homesaleInfo : null;
  // Interior features live in their own table; they are saved alongside the homesale record in one request.
  const interiorFeatures = props.homesale ? props.homesale.interiorFeatures : null;

  const inspections = ['General', 'Pest', 'Pool', 'Radon', 'Septic', 'Stucco ID', 'Well'];

  const typeOptions =
    typeOfHomesEnum && typeOfHomesEnum.length > 0
      ? typeOfHomesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    const sidingTypes =
    enumerations && enumerations.sidingTypes && enumerations.sidingTypes.length > 0
      ? enumerations.sidingTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    const hoaPaymentScheduleOptions =
    enumerations && enumerations.hOAPaymentScheduleTypes && enumerations.hOAPaymentScheduleTypes.length > 0
      ? enumerations.hOAPaymentScheduleTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const tabs = [{ header: 'Property Info', order: 1, iconPath: ['fas', 'house-user'] }];

  const interiorFeatureSummaries = [
    {
      header: 'Number of Bedrooms',
      accessorKey: 'numBedrooms',
      type: 'number',
      required: false,
      value: interiorFeatures ? interiorFeatures.numBedrooms : null,
      tab: 1
    },
    {
      header: 'Number of Bathrooms',
      accessorKey: 'numBathrooms',
      type: 'number',
      required: false,
      value: interiorFeatures ? interiorFeatures.numBathrooms : null,
      tab: 1
    },
    {
      header: 'Square Feet',
      accessorKey: 'squareFeet',
      type: 'number',
      required: false,
      value: interiorFeatures ? interiorFeatures.squareFeet : null,
      tab: 1
    },
    {
      header: 'Heat Type',
      accessorKey: 'heatTypeId',
      type: 'dropdown-v2',
      required: false,
      value: interiorFeatures ? interiorFeatures.heatTypeId : null,
      options: enumerations && enumerations.heatTypes ? enumerations.heatTypes.filter(s => s.isActive === true) : [],
      tab: 1
    },
    {
      header: 'Water Type',
      accessorKey: 'waterTypeId',
      type: 'dropdown-v2',
      required: false,
      value: interiorFeatures ? interiorFeatures.waterTypeId : null,
      options: enumerations && enumerations.waterTypes ? enumerations.waterTypes.filter(s => s.isActive === true) : [],
      tab: 1
    },
    {
      header: 'Sewer Type',
      accessorKey: 'sewerTypeId',
      type: 'dropdown-v2',
      required: false,
      value: interiorFeatures ? interiorFeatures.sewerTypeId : null,
      options: enumerations && enumerations.sewerTypes ? enumerations.sewerTypes.filter(s => s.isActive === true) : [],
      tab: 1
    },
    {
      header: 'Basement',
      accessorKey: 'hasBasement',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasBasement : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasBasement" label="Active" checked={cell.row.original.hasBasement} disabled={true} />
    },
    {
      header: 'Is Basement Finished',
      accessorKey: 'hasFinishedBasement',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasFinishedBasement : false,
      showWhen: () => {
        return interiorFeatures && interiorFeatures.hasBasement === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasBasement === true;
      },
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasFinishedBasement" label="Active" checked={cell.row.original.hasFinishedBasement} disabled={true} />
    },
    {
      header: 'Garage',
      accessorKey: 'hasGarage',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasGarage : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasGarage" label="Active" checked={cell.row.original.hasGarage} disabled={true} />
    },
    {
      header: 'Is Garage Attached',
      accessorKey: 'hasAttachedGarage',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasAttachedGarage : false,
      showWhen: () => {
        return interiorFeatures && interiorFeatures.hasGarage === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasGarage === true;
      },
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasAttachedGarage" label="Active" checked={cell.row.original.hasAttachedGarage} disabled={true} />
    },
    {
      header: 'Garage Parking Spaces',
      accessorKey: 'garageParkingSpaces',
      type: 'number',
      required: false,
      value: interiorFeatures ? interiorFeatures.garageParkingSpaces : null,
      showWhen: () => {
        return interiorFeatures && interiorFeatures.hasGarage === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasGarage === true;
      },
      tab: 1
    },
    {
      header: 'Has Fireplace',
      accessorKey: 'hasFireplace',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasFireplace : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasFireplace" label="Active" checked={cell.row.original.hasFireplace} disabled={true} />
    },
    {
      header: 'Has Underground Tanks',
      accessorKey: 'hasUndergroundTanks',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasUndergroundTanks : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasUndergroundTanks" label="Active" checked={cell.row.original.hasUndergroundTanks} disabled={true} />
    },
    {
      header: 'Tanks Last Pumped/Serviced',
      accessorKey: 'undergroundTanksLastPumpedDate',
      type: 'date',
      required: false,
      value: interiorFeatures ? interiorFeatures.undergroundTanksLastPumpedDate : '',
      showWhen: () => {
        return interiorFeatures && interiorFeatures.hasUndergroundTanks === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasUndergroundTanks === true;
      },
      tab: 1
    },
    {
      header: 'Has Pool',
      accessorKey: 'hasPool',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasPool : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasPool" label="Active" checked={cell.row.original.hasPool} disabled={true} />
    },
    {
      header: 'Pool Type',
      accessorKey: 'poolTypeId',
      type: 'dropdown-v2',
      required: false,
      value: interiorFeatures ? interiorFeatures.poolTypeId : null,
      options: enumerations && enumerations.poolTypes ? enumerations.poolTypes.filter(s => s.isActive === true) : [],
      showWhen: () => {
        return interiorFeatures && interiorFeatures.hasPool === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasPool === true;
      },
      tab: 1
    },
    {
      header: 'Hot Tub',
      accessorKey: 'hasHotTub',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasHotTub : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasHotTub" label="Active" checked={cell.row.original.hasHotTub} disabled={true} />
    },
    {
      header: 'Sprinkler System',
      accessorKey: 'hasSprinklerSystem',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasSprinklerSystem : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasSprinklerSystem" label="Active" checked={cell.row.original.hasSprinklerSystem} disabled={true} />
    },
    {
      header: 'Water Softener',
      accessorKey: 'hasWaterSoftener',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasWaterSoftener : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasWaterSoftener" label="Active" checked={cell.row.original.hasWaterSoftener} disabled={true} />
    },
    {
      header: 'Owns/Rents Water Softener',
      accessorKey: 'ownsOrRentsWaterSoftener',
      type: 'dropdown',
      required: false,
      value: interiorFeatures ? interiorFeatures.ownsOrRentsWaterSoftener : null,
      options: ['Owns', 'Rents'],
      showWhen: () => {
        return interiorFeatures && interiorFeatures.hasWaterSoftener === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasWaterSoftener === true;
      },
      tab: 1
    },
    {
      header: 'Alarm System',
      accessorKey: 'hasAlarmSystem',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasAlarmSystem : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasAlarmSystem" label="Active" checked={cell.row.original.hasAlarmSystem} disabled={true} />
    },
    {
      header: 'Alarm System Company',
      accessorKey: 'alarmSystemCompany',
      type: 'text',
      required: false,
      value: interiorFeatures ? interiorFeatures.alarmSystemCompany : '',
      showWhen: () => {
        return interiorFeatures && interiorFeatures.hasAlarmSystem === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasAlarmSystem === true;
      },
      tab: 1
    },
    {
      header: 'Alarm System Contract Term',
      accessorKey: 'alarmSystemContractTerm',
      type: 'text',
      required: false,
      value: interiorFeatures ? interiorFeatures.alarmSystemContractTerm : '',
      showWhen: () => {
        return interiorFeatures && interiorFeatures.hasAlarmSystem === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasAlarmSystem === true;
      },
      tab: 1
    },
    {
      header: 'Solar Panels',
      accessorKey: 'hasSolarPanels',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasSolarPanels : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasSolarPanels" label="Active" checked={cell.row.original.hasSolarPanels} disabled={true} />
    },
    {
      header: 'Solar Panel Type',
      accessorKey: 'solarPanelTypeId',
      type: 'dropdown-v2',
      required: false,
      value: interiorFeatures ? interiorFeatures.solarPanelTypeId : null,
      options: enumerations && enumerations.solarPanelTypes ? enumerations.solarPanelTypes.filter(s => s.isActive === true) : [],
      showWhen: () => {
        return interiorFeatures && interiorFeatures.hasSolarPanels === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasSolarPanels === true;
      },
      tab: 1
    },
    {
      header: 'Solar Panels Staying with Property',
      accessorKey: 'isSolarPanelStayingWithProperty',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.isSolarPanelStayingWithProperty : false,
      showWhen: () => {
        return interiorFeatures && interiorFeatures.hasSolarPanels === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hasSolarPanels === true;
      },
      tab: 1,
      Cell: ({ cell }) => (
        <Checkbox name="isSolarPanelStayingWithProperty" label="Active" checked={cell.row.original.isSolarPanelStayingWithProperty} disabled={true} />
      )
    },
    {
      header: 'Warranties on Home',
      accessorKey: 'hasWarrantiesOnHome',
      type: 'checkbox',
      required: false,
      value: interiorFeatures ? interiorFeatures.hasWarrantiesOnHome : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hasWarrantiesOnHome" label="Active" checked={cell.row.original.hasWarrantiesOnHome} disabled={true} />
    },
    {
      header: 'Capital Improvements/Remodeling Since Purchase',
      accessorKey: 'remodelingsSincePurchase',
      type: 'text',
      required: false,
      value: interiorFeatures ? interiorFeatures.remodelingsSincePurchase : '',
      tab: 1
    },
    {
      header: 'Easements',
      accessorKey: 'easements',
      type: 'text',
      required: false,
      value: interiorFeatures ? interiorFeatures.easements : '',
      tab: 1
    },
    {
      header: 'Special Assessments',
      accessorKey: 'specialAssessments',
      type: 'notes',
      required: false,
      value: interiorFeatures ? interiorFeatures.specialAssessments : '',
      tab: 1
    },
    {
      header: 'Known Defects',
      accessorKey: 'knownDefects',
      type: 'notes',
      required: false,
      value: interiorFeatures ? interiorFeatures.knownDefects : '',
      tab: 1
    },
    {
      header: 'Outstanding Insurance Claims',
      accessorKey: 'outstandingInsuranceClaims',
      type: 'notes',
      required: false,
      value: interiorFeatures ? interiorFeatures.outstandingInsuranceClaims : '',
      tab: 1
    },
    {
      header: 'Inspections to Order',
      accessorKey: 'inspectionsToOrder',
      type: 'multi-select',
      options: inspections,
      required: false,
      tab: 1,
      value:
        interiorFeatures && Array.isArray(interiorFeatures.inspectionsToOrder)
          ? interiorFeatures.inspectionsToOrder
          : interiorFeatures && typeof interiorFeatures.inspectionsToOrder === 'string' && interiorFeatures.inspectionsToOrder.length > 0
            ? interiorFeatures.inspectionsToOrder.split(',')
            : [],
      Cell: ({ cell }) => {
        const val = cell.getValue();
        if (!val || (Array.isArray(val) && val.length === 0)) return '-';
        const arr = Array.isArray(val) ? val : typeof val === 'string' && val.length > 0 ? val.split(',') : [];
        return arr.length > 0 ? arr.map(f => <div key={f}>{f}</div>) : '-';
      }
    }
  ];

  const summaries = [
    {
      header: 'Property Type',
      accessorKey: 'propertyTypeId',
      type: 'dropdown-v2',
      required: false,
      value: homesaleInfo ? homesaleInfo.propertyTypeId : null,
      options: typeOptions,
      tab: 1
    },
    {
      header: 'Original Purchase Amount',
      accessorKey: 'originalPurchaseAmount',
      type: 'money',
      required: false,
      value: homesaleInfo ? homesaleInfo.originalPurchaseAmount : false,
      tab: 1
    },
    {
      header: 'Original Purchase Date',
      accessorKey: 'originalPurchaseDate',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.originalPurchaseDate : '',
      tab: 1
    },
    {
      header: 'Est. Sale Amount',
      accessorKey: 'satisfiedOfferAmount',
      type: 'money',
      required: false,
      value: homesaleInfo ? homesaleInfo.satisfiedOfferAmount : '',
      tab: 1
    },
    {
      header: 'HO Disclosure Sent',
      accessorKey: 'hoDisclosureSent',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.hoDisclosureSent : '',
      tab: 1
    },
    {
      header: 'HO Disclosure Received',
      accessorKey: 'hoDisclosureReceived',
      type: 'date',
      required: false,
      value: homesaleInfo ? homesaleInfo.hoDisclosureReceived : false,
      tab: 1
    },
    {
      header: 'Homeowners Association',
      accessorKey: 'isHomeownersAssociation',
      type: 'checkbox',
      required: false,
      value: homesaleInfo ? homesaleInfo.isHomeownersAssociation : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="isHomeownersAssociation" label="Active" checked={cell.row.original.isHomeownersAssociation} disabled={true} />
    },
    {
      header: 'HOA Payment Schedule',
      accessorKey: 'hoaPaymentScheduleId',
      type: 'dropdown-v2',
      required: false,
      value: homesaleInfo ? homesaleInfo.hoaPaymentScheduleId : '',
      options: hoaPaymentScheduleOptions,
      showWhen: () => {
                return homesaleInfo && homesaleInfo.isHomeownersAssociation === true;
            },
            showWhenModal: ({ values }) => {
                return values && values.isHomeownersAssociation === true;
            },
      tab: 1
    },
    {
      header: 'HOA Payment Amount',
      accessorKey: 'hoaPaymentAmount',
      type: 'money',
      required: false,
      value: homesaleInfo ? homesaleInfo.hoaPaymentAmount : '',
      showWhen: () => {
                return homesaleInfo && homesaleInfo.isHomeownersAssociation === true;
            },
            showWhenModal: ({ values }) => {
                return values && values.isHomeownersAssociation === true;
            },
      tab: 1
    },
    {
      header: 'Taxes Escrowed',
      accessorKey: 'isTaxesEscrowed',
      type: 'checkbox',
      required: false,
      value: homesaleInfo ? homesaleInfo.isTaxesEscrowed : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="isTaxesEscrowed" label="Active" checked={cell.row.original.isTaxesEscrowed} disabled={true} />
    },
    {
      header: 'Insurance Escrowed',
      accessorKey: 'isInsuranceEscrowed',
      type: 'checkbox',
      required: false,      
      value: homesaleInfo ? homesaleInfo.isInsuranceEscrowed : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="isInsuranceEscrowed" label="Active" checked={cell.row.original.isInsuranceEscrowed} disabled={true} />
    },
    {
      header: 'Flood Insurance Required',
      accessorKey: 'isFloodInsuranceRequired',
      type: 'checkbox',
      required: false,
      value: homesaleInfo ? homesaleInfo.isFloodInsuranceRequired : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="isFloodInsuranceRequired" label="Active" checked={cell.row.original.isFloodInsuranceRequired} disabled={true} />
    },
    {
      header: 'Desired List Price',
      accessorKey: 'desiredListPrice',
      type: 'money',
      required: false,
      value: homesaleInfo ? homesaleInfo.desiredListPrice : '',
      tab: 1
    },
    {
      header: 'Satisfactory Offer Price',
      accessorKey: 'satisfactoryOfferPrice',
      type: 'money',
      required: false,
      value: homesaleInfo ? homesaleInfo.satisfactoryOfferPrice : '',
      tab: 1
    },
    { dividerLine: true, tab: 1 },
    {
      header: 'Built Before 78',
      accessorKey: 'wasBuiltPre1978',
      type: 'checkbox',
      required: false,
      value: homesaleInfo ? homesaleInfo.wasBuiltPre1978 : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="wasBuiltPre1978" label="Active" checked={cell.row.original.wasBuiltPre1978} disabled={true} />
    },
    {
      header: 'New Construction',
      accessorKey: 'isNewConstruction',
      type: 'checkbox',
      required: false,
      value: homesaleInfo ? homesaleInfo.isNewConstruction : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="isNewConstruction" label="Active" checked={cell.row.original.isNewConstruction} disabled={true} />
    },
    {
      header: 'Overall Style',
      accessorKey: 'overallStyle',
      type: 'text',
      required: false,
      value: homesaleInfo ? homesaleInfo.overallStyle : '',
      tab: 1
    },
    {
      header: 'Siding Type',
      accessorKey: 'sidingTypeId',
      type: 'dropdown-v2',
      required: false,
      value: homesaleInfo ? homesaleInfo.sidingTypeId : null,
      options: sidingTypes,
      tab: 1
    },
    {
      header: 'Lot Acreage',
      // API/DB spelling is lotAcerage
      accessorKey: 'lotAcerage',
      type: 'number',
      required: false,
      value: homesaleInfo ? homesaleInfo.lotAcerage : 0,
      tab: 1  
    },
    {
      header: 'Age of Roof',
      accessorKey: 'ageOfRoof',
      type: 'number',
      required: false,
      value: homesaleInfo ? homesaleInfo.ageOfRoof : 0,
      tab: 1
    },
    {
      header: 'Roof Replaced',
      accessorKey: 'isRoofReplaced',
      type: 'checkbox',
      required: false,
      value: homesaleInfo ? homesaleInfo.isRoofReplaced : false,
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="isRoofReplaced" label="Active" checked={cell.row.original.isRoofReplaced} disabled={true} />
    },
    { dividerLine: true, tab: 1 },
    ...interiorFeatureSummaries,
    { dividerLine: true, tab: 1 },
    {
      header: 'Notes',
      accessorKey: 'homesaleNote',
      type: 'notes',
      required: false,
      value: homesaleInfo ? homesaleInfo.homesaleNote : '',
      showBelow: true,
      tab: 1
    }
  ];

  const isEdited = (summary, values) =>
    !!summary.accessorKey && String(values[summary.accessorKey] ?? '') !== String(summary.value ?? '');

  const updateFields = async (tab, values) => {
    // The homesale record and its interior features are saved separately and both reject stale row versions, so each
    // part is only sent when one of its own fields was edited.
    const propertyInfoEdited = summaries.some(s => !interiorFeatureSummaries.includes(s) && isEdited(s, values));
    const interiorFeaturesEdited = interiorFeatureSummaries.some(s => isEdited(s, values));
    if (!propertyInfoEdited && !interiorFeaturesEdited) return true;

    setIsLoading(true);

    let newValues = { ...homesaleInfo };

    newValues.propertyTypeId = values.propertyTypeId;
    newValues.originalPurchaseAmount = values.originalPurchaseAmount;
    newValues.originalPurchaseDate = values.originalPurchaseDate === '' ? null : values.originalPurchaseDate;
    newValues.satisfiedOfferAmount = values.satisfiedOfferAmount;
    newValues.hoDisclosureSent = values.hoDisclosureSent;
    newValues.hoDisclosureReceived = values.hoDisclosureReceived;
    newValues.wasBuiltPre1978 = values.wasBuiltPre1978;
    newValues.desiredListPrice = values.desiredListPrice;
    newValues.satisfactoryOfferPrice = values.satisfactoryOfferPrice;
    newValues.isNewConstruction = values.isNewConstruction;
    newValues.overallStyle = values.overallStyle;
    newValues.sidingTypeId = values.sidingTypeId;
    newValues.lotAcerage = values.lotAcerage;
    newValues.ageOfRoof = values.ageOfRoof;
    newValues.isRoofReplaced = values.isRoofReplaced;
      newValues.isHomeownersAssociation = values.isHomeownersAssociation;
      newValues.hoaPaymentScheduleId = values.hoaPaymentScheduleId;
      newValues.hoaPaymentAmount = values.hoaPaymentAmount;
      newValues.isTaxesEscrowed = values.isTaxesEscrowed;
      newValues.isInsuranceEscrowed = values.isInsuranceEscrowed;
      newValues.isFloodInsuranceRequired = values.isFloodInsuranceRequired;

    newValues.homesaleNote = values.homesaleNote;
    newValues.satisfiedOfferAmount = values.satisfiedOfferAmount;

    let newInteriorValues = { ...interiorFeatures };

    newInteriorValues.numBedrooms = parseInt(values.numBedrooms, 10);
    newInteriorValues.numBathrooms = parseInt(values.numBathrooms, 10);
    newInteriorValues.squareFeet = parseInt(values.squareFeet, 10);
    newInteriorValues.hasBasement = values.hasBasement;
    newInteriorValues.hasFinishedBasement = values.hasFinishedBasement;
    newInteriorValues.hasGarage = values.hasGarage;
    newInteriorValues.hasAttachedGarage = values.hasAttachedGarage;
    newInteriorValues.garageParkingSpaces = values.garageParkingSpaces;
    newInteriorValues.hasFireplace = values.hasFireplace;
    newInteriorValues.heatTypeId = values.heatTypeId;
    newInteriorValues.waterTypeId = values.waterTypeId;
    newInteriorValues.sewerTypeId = values.sewerTypeId;
    newInteriorValues.hasUndergroundTanks = values.hasUndergroundTanks;
    newInteriorValues.undergroundTanksLastPumpedDate = values.undergroundTanksLastPumpedDate === '' ? null : values.undergroundTanksLastPumpedDate;
    newInteriorValues.hasPool = values.hasPool;
    newInteriorValues.poolTypeId = values.poolTypeId;
    newInteriorValues.hasHotTub = values.hasHotTub;
    newInteriorValues.hasSprinklerSystem = values.hasSprinklerSystem;
    newInteriorValues.hasWaterSoftener = values.hasWaterSoftener;
    newInteriorValues.ownsOrRentsWaterSoftener = values.ownsOrRentsWaterSoftener;
    newInteriorValues.hasAlarmSystem = values.hasAlarmSystem;
    newInteriorValues.alarmSystemCompany = values.alarmSystemCompany;
    newInteriorValues.alarmSystemContractTerm = values.alarmSystemContractTerm;
    newInteriorValues.hasSolarPanels = values.hasSolarPanels;
    newInteriorValues.solarPanelTypeId = values.solarPanelTypeId;
    newInteriorValues.isSolarPanelStayingWithProperty = values.isSolarPanelStayingWithProperty;
    newInteriorValues.hasWarrantiesOnHome = values.hasWarrantiesOnHome;
    newInteriorValues.remodelingsSincePurchase = values.remodelingsSincePurchase;
    newInteriorValues.easements = values.easements;
    newInteriorValues.specialAssessments = values.specialAssessments;
    newInteriorValues.knownDefects = values.knownDefects;
    newInteriorValues.outstandingInsuranceClaims = values.outstandingInsuranceClaims ? values.outstandingInsuranceClaims : '';
    // Stored as a comma-separated list of the selected inspection names.
    if (Array.isArray(values.inspectionsToOrder)) {
      newInteriorValues.inspectionsToOrder = values.inspectionsToOrder.join(',');
    }

    const resp = await props.updateHomesalePropertyInfo(homesaleInfo.authorizationFileId, {
      homesaleInfo: propertyInfoEdited ? newValues : null,
      interiorFeatures: interiorFeaturesEdited ? newInteriorValues : null
    });
    if (resp.type === UPDATE_HOMESALE_PROPERTY_INFO_FAILURE) {
      props.showToast('Failed to update homesale property info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      // One part may have saved before the other failed; reload so a retry only resends what is still unsaved.
      await props.getHomesaleInfo(homesaleInfo.authorizationFileId);
      setIsLoading(false);
      return false;
    }

    // The response is the reloaded homesale (interior features and new row versions included), which the reducer stores.
    setIsLoading(false);
    return true;
  };

  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={5}
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={isReadOnly}
    />
  );
};

const mapStateToProps = state => {
  const { homesalePropertyTypes } = state.enumerations.allEnums;
  return {
    typeOfHomesEnum: homesalePropertyTypes
  };
};

export default compose(
  connect(mapStateToProps, {
    updateHomesalePropertyInfo,
    postHomesaleInfo,
    showToast,
    getHomesaleInfo
  })
)(PropertyInfoCard);
